<script>
	export let height = 25;
	export let width = height;
	export let fill = "black";
	export let style = "";
</script>

<svg
	viewBox="0 0 29 29"
	fill="none"
	xmlns="http://www.w3.org/2000/svg"
	{width}
	{height}
	{style}
>
	<path
		d="M27.9608 4.03546C28.7418 3.25441 28.7418 1.98809 27.9608 1.20704L27.793 1.03921C27.0119 0.258166 25.7456 0.258165 24.9645 1.03921L15.9142 10.0895C15.1332 10.8706 13.8668 10.8706 13.0858 10.0895L4.03546 1.03921C3.25441 0.258164 1.98808 0.258165 1.20704 1.03921L1.03921 1.20704C0.258166 1.98808 0.258165 3.25441 1.03921 4.03546L10.0895 13.0858C10.8706 13.8668 10.8706 15.1332 10.0895 15.9142L1.03921 24.9645C0.258164 25.7456 0.258165 27.0119 1.03921 27.793L1.20704 27.9608C1.98808 28.7418 3.25441 28.7418 4.03546 27.9608L13.0858 18.9105C13.8668 18.1294 15.1332 18.1294 15.9142 18.9105L24.9645 27.9608C25.7456 28.7418 27.0119 28.7418 27.793 27.9608L27.9608 27.793C28.7418 27.0119 28.7418 25.7456 27.9608 24.9645L18.9105 15.9142C18.1294 15.1332 18.1294 13.8668 18.9105 13.0858L27.9608 4.03546Z"
		{fill}
	/>
</svg>

<style>
</style>
